<template>
  <div class="products-product">
    <router-link
      v-slot="{ href, navigate }"
      :to="{ name: 'product', params: { id: product.id }, ...outermostLinkTo }"
      class="h-full"
    >
      <a :href="href" @click.stop="navigate" class="products-product-content">
        <img class="products-product-image" :src="product.thumbnail" alt="product" />
        <div>
          <span class="products-product-name">{{ stripOutChroma(product.display_name) }}</span>
          <router-link
            :to="{ name: 'post-training-lessons', params: { id: product.id } }"
            v-if="isPostTraining"
            class="uppercase products-product-link"
          >
            {{ $t('postTraining.link') }} →
          </router-link>
          <router-link
            :to="{ name: 'training-lessons', params: { id: product.id } }"
            v-else-if="hasPretraining(product)"
            class="uppercase products-product-link"
          >
            {{ $t('product.link') }} →
          </router-link>
          <router-link
            :to="{
              name: 'product',
              params: { id: product.id },
              ...outermostLinkTo,
            }"
            v-if="isChromaProduct(product) && !isPostTraining"
            class="uppercase products-product-link"
          >
            {{ $t('product.chroma_link') }} →
          </router-link>
        </div>
      </a>
    </router-link>
  </div>
</template>

<script>
import { isBlacklisted, stripOutChromaVersion, isChroma } from '@/utils';

export default {
  name: 'Product',
  props: {
    product: Object,
    isPostTraining: { type: Boolean, default: false },
    outermostLinkTo: { type: Object, default: () => ({}) },
  },
  methods: {
    hasPretraining(product) {
      const name = product.display_name;
      const hasVideos = product.has_videos;
      return hasVideos && !isBlacklisted(name);
    },
    stripOutChroma(name) {
      return stripOutChromaVersion(name);
    },
    isChromaProduct(product) {
      return isChroma(product.display_name);
    },
  },
};
</script>
